import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { COLORS } from '../../../core/constants/colors';

export const CompletionStep: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Auto-redirect to dashboard after a short delay
    const timer = setTimeout(() => {
      navigate('/dashboard', { replace: true });
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="flex-1 text-center py-8">
      <div className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center" style={{ backgroundColor: COLORS.primary.softLime + '20' }}>
        <svg className="w-10 h-10" style={{ color: COLORS.primary.softLime }} viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
        </svg>
      </div>
      <h2 className="text-3xl font-bold mb-3" style={{ color: COLORS.primary.persianIndigo }}>
        Company profile completed!
      </h2>
      <p className="text-sm mb-6" style={{ color: COLORS.primary.persianIndigo, opacity: 0.7 }}>
        Redirecting you to the dashboard...
      </p>
      <button
        onClick={() => navigate('/dashboard', { replace: true })}
        className="px-6 py-3 rounded-lg font-semibold text-white transition-all hover:shadow-md"
        style={{ backgroundColor: COLORS.extended.azure }}
      >
        Go to dashboard now
      </button>
    </div>
  );
};

